import { lazy } from 'react';

const SongDedicationModule = lazy(() => import('../components/SongDedicationModule'));
const MemoryMosaicModule = lazy(() => import('../components/MemoryMosaicModule'));
const GeometricDecryptModule = lazy(() => import('../components/GeometricDecryptModule'));
const TimeTogetherModule = lazy(() => import('../components/TimeTogetherModule'));
const HeroMediaModule = lazy(() => import('../components/HeroMediaModule'));
const VideoPlayerModule = lazy(() => import('../components/VideoPlayerModule'));
const SharedAlbumModule = lazy(() => import('../components/SharedAlbumModule'));
const MemoryCapsuleModule = lazy(() => import('../components/MemoryCapsuleModule'));
const ReactionModule = lazy(() => import('../components/ReactionModule'));
const ThenNowModule = lazy(() => import('../components/ThenNowModule'));
const FrameGalleryModule = lazy(() => import('../components/FrameGalleryModule'));
const MemoryMapModule = lazy(() => import('../components/MemoryMapModule'));
const PolaroidBoothModule = lazy(() => import('../components/PolaroidBoothModule'));
const TinyMuseumModule = lazy(() => import('../components/TinyMuseumModule'));
const TimelineModule = lazy(() => import('../components/TimelineModule'));
const LeaveNoteModule = lazy(() => import('../components/LeaveNoteModule'));
const MomVoiceNoteModule = lazy(() => import('../components/MomVoiceNoteModule'));
const UnlockSequenceModule = lazy(() => import('../components/UnlockSequenceModule'));
const MediaCard = lazy(() => import('../components/MediaCard'));
const AIGeneratorModule = lazy(() => import('../components/AIGeneratorModule'));

const ADVANCED_MODULE_COMPONENTS = {
  song_dedication: SongDedicationModule,
  song: SongDedicationModule,
  video_player: VideoPlayerModule,
  video: VideoPlayerModule,
  hero_media: HeroMediaModule,
  shared_album: SharedAlbumModule,
  memory_mosaic: MemoryMosaicModule,
  geometric_decrypt: GeometricDecryptModule,
  time_together: TimeTogetherModule,
  timeline: TimelineModule,
  memory_map: MemoryMapModule,
  then_now: ThenNowModule,
  frame_gallery: FrameGalleryModule,
  flip_card: MemoryCapsuleModule,
  tiny_museum: TinyMuseumModule,
  reaction: ReactionModule,
  polaroid_booth: PolaroidBoothModule,
  affection_tapper: ReactionModule,
  leave_note: LeaveNoteModule,
  mom_voice_note: MomVoiceNoteModule,
  unlock_sequence: UnlockSequenceModule,
  media_card: MediaCard,
  ai_generator: AIGeneratorModule,
};

export default ADVANCED_MODULE_COMPONENTS;
